/*
  Abba & Co. The Next Reminder (build plan v01 stage 1). Thumbs on the hub and on each idea page.
  Votes go to the store app through the Shopify app proxy (/apps/next): Shopify signs each request and
  tells the app which customer is signed in, so a vote needs no email link. One vote per idea, and it
  can be switched; the same thumb again takes it back. Counts show once 25 people have responded.
  Not signed in: the thumb takes the visitor to sign in and back, and the vote counts on return.
  A first vote asks once about email, with the box ticked for US visitors (set by the theme).
*/
(() => {
  const cfgEl = document.querySelector('[data-next-config]');
  if (!cfgEl || window.__abbacoNext) return;
  window.__abbacoNext = true;
  const cfg = cfgEl.dataset;
  const signedIn = cfg.signedIn === 'true';
  const toastEl = document.querySelector('[data-next-toast]');
  const ask = document.querySelector('[data-next-ask]');
  let state = null;
  let busy = false;

  const toast = (t) => {
    if (!toastEl || !t) return;
    toastEl.textContent = t;
    toastEl.classList.add('is-on');
    clearTimeout(toast.h);
    toast.h = setTimeout(() => toastEl.classList.remove('is-on'), 2600);
  };
  const esc = (x) => String(x ?? '').replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const nameOf = (h) => {
    const el = document.querySelector(`#Idea-${CSS.escape(h)} .anr-cap b`) || document.querySelector('.anr-vbar__name');
    return el ? el.lastChild.textContent.trim() : '';
  };
  const api = async (path, body) => {
    const r = await fetch(`${cfg.proxy}/${path}`, body
      ? { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body), credentials: 'same-origin' }
      : { credentials: 'same-origin', headers: { Accept: 'application/json' } });
    const j = await r.json().catch(() => ({ ok: false }));
    return { status: r.status, ...j };
  };

  // Paint every thumb, count and "voted" block from the state the app sent.
  function paint() {
    const mine = (state && state.mine) || {};
    document.querySelectorAll('[data-next-idea]').forEach((bar) => {
      const v = mine[bar.dataset.nextIdea];
      bar.querySelectorAll('[data-next-vote]').forEach((b) => b.setAttribute('aria-pressed', String(Boolean(v && v.choice === b.dataset.nextVote))));
    });
    document.querySelectorAll('[data-next-counts]').forEach((el) => {
      const c = state && state.counts && state.counts[el.dataset.nextCounts];
      el.innerHTML = c && c.shown
        ? `<p class="anr-counts"><span><b>${c.up}</b>${esc(cfg.tUp)}</span><span><b>${c.down}</b>${esc(cfg.tDown)}</span></p>`
        : `<p class="anr-first">${esc(cfg.tFirst)}<span>${esc(cfg.tFirstSmall)}</span></p>`;
    });
    document.querySelectorAll('[data-next-voted]').forEach((el) => { el.hidden = !mine[el.dataset.nextVoted]; });
  }

  // The one time email question. Resolves with true/false for the box, or null if the visitor backs out.
  function askConsent() {
    if (!ask) return Promise.resolve(false);
    return new Promise((resolve) => {
      const go = ask.querySelector('[data-next-ask-go]');
      const no = ask.querySelector('[data-next-ask-cancel]');
      const box = ask.querySelector('[data-next-consent]');
      const done = (v) => { ask.classList.remove('is-on'); ask.setAttribute('aria-hidden', 'true'); go.onclick = no.onclick = null; resolve(v); };
      go.onclick = () => done(Boolean(box && box.checked));
      no.onclick = () => done(null);
      ask.classList.add('is-on'); ask.setAttribute('aria-hidden', 'false');
      setTimeout(() => go.focus(), 260);
    });
  }

  async function vote(idea, choice) {
    if (!signedIn) {
      // Back here after signing in, with the vote waiting in the address.
      const back = new URL(location.href);
      back.searchParams.set('next_vote', `${idea}:${choice}`);
      back.hash = '';
      const path = back.pathname + back.search;
      location.href = cfg.login.replace(/return_to=[^&]*/, `return_to=${encodeURIComponent(path)}`);
      return;
    }
    if (busy) return;
    if (!state) { toast(cfg.tClosed); return; }
    let consent = false;
    if (!state.consentAsked) {
      const ans = await askConsent();
      if (ans === null) return;
      consent = ans;
    }
    busy = true;
    try {
      const r = await api('vote', { idea, choice, consent });
      if (!r.ok) { toast(r.error || cfg.tError); return; }
      state.consentAsked = true;
      state.mine = state.mine || {};
      if (r.choice) state.mine[idea] = { ...(state.mine[idea] || {}), choice: r.choice }; else delete state.mine[idea];
      state.counts[idea] = r.counts;
      paint();
      toast(!r.choice ? cfg.tRemoved : r.changed ? cfg.tChanged : cfg.tCounted.replace('[name]', nameOf(idea)));
    } catch { toast(cfg.tError); }
    finally { busy = false; }
  }

  document.addEventListener('click', async (e) => {
    const v = e.target.closest('[data-next-vote]');
    if (v) { const bar = v.closest('[data-next-idea]'); return vote(bar.dataset.nextIdea, v.dataset.nextVote); }
    const sh = e.target.closest('[data-next-share]');
    if (sh) {
      const url = new URL(sh.dataset.nextShare, location.origin).href;
      try { if (navigator.share) await navigator.share({ title: sh.dataset.nextShareTitle, url }); else { await navigator.clipboard.writeText(url); toast(cfg.tCopied); } } catch { /* closed the share sheet */ }
      return;
    }
    const all = e.target.closest('[data-next-all]');
    if (all) { document.querySelectorAll('[data-next-extra]').forEach((li) => { li.hidden = false; }); all.closest('p').hidden = true; return; }
    const st = e.target.closest('[data-next-step]');
    if (st) { const tr = document.querySelector('[data-next-steps]'); if (tr) tr.scrollBy({ left: Number(st.dataset.nextStep) * tr.clientWidth * 0.8, behavior: 'smooth' }); }
  });

  // The private why on an idea page.
  document.querySelectorAll('[data-next-why]').forEach((f) => f.addEventListener('submit', async (e) => {
    e.preventDefault();
    const input = f.querySelector('input');
    const text = input.value.trim();
    if (!text) return;
    const btn = f.querySelector('button');
    btn.disabled = true;
    try {
      const r = await api('why', { idea: f.dataset.nextWhy, text });
      if (!r.ok) { toast(r.error || cfg.tError); return; }
      f.hidden = true;
      const sent = f.parentElement.querySelector('[data-next-why-sent]');
      if (sent) sent.hidden = false;
    } catch { toast(cfg.tError); }
    finally { btn.disabled = false; }
  }));

  // The steps light up in order as they come into view.
  const steps = document.querySelectorAll('.anr-step');
  if (steps.length && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver((es) => es.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-on'); io.unobserve(en.target); } }), { threshold: 0.6 });
    steps.forEach((s) => io.observe(s));
  }

  // On an idea page: the vote bar shows while the story is read, and hides while the vote block is on screen.
  const vbar = document.querySelector('[data-next-vbar]');
  const respond = document.querySelector('[data-next-respond]');
  const story = document.getElementById('declaration');
  if (vbar && respond && story && 'IntersectionObserver' in window) {
    let inStory = false, atVote = false;
    const set = () => { const on = inStory && !atVote; vbar.classList.toggle('is-on', on); vbar.setAttribute('aria-hidden', String(!on)); };
    new IntersectionObserver(([en]) => { inStory = en.isIntersecting; set(); }).observe(story);
    new IntersectionObserver(([en]) => { atVote = en.isIntersecting; set(); }).observe(respond);
  }

  // Load the counts and this visitor's votes, then count a vote that was waiting for sign in.
  (async () => {
    try {
      const r = await api('state');
      if (!r.ok) throw new Error('closed');
      state = r;
      paint();
    } catch {
      document.querySelectorAll('[data-next-closed]').forEach((el) => { el.hidden = false; });
      return;
    }
    const u = new URL(location.href);
    const waiting = u.searchParams.get('next_vote');
    if (waiting) {
      u.searchParams.delete('next_vote');
      history.replaceState(null, '', u.pathname + u.search + u.hash);
      const [idea, choice] = waiting.split(':');
      const mine = state.mine && state.mine[idea];
      // Only if it is not already their vote, so a reload never takes it back.
      if (signedIn && idea && choice && !(mine && mine.choice === choice)) vote(idea, choice);
    }
  })();
})();
